import Vue from 'vue'

const maxTradeRevertUpdates = 50

function rememberTradeRevertInventoryUpdates (state, payload) {
  const trade = payload ? payload.trade : null
  if (!trade || !Array.isArray(trade.users) || !trade.server) {
    return
  }

  const activeUserId = payload ? payload.activeUserId : null
  let updates = state.tradeRevertInventoryUpdates.filter(existing => {
    return !(existing.server === trade.server && trade.users.some(user => Number(user.user_id) === Number(existing.user_id)))
  })
  trade.users.forEach(user => {
    if (!user || !Array.isArray(user.items)) {
      return
    }
    updates.push({
      server: trade.server,
      user_id: Number(user.user_id),
      active: activeUserId !== null && Number(activeUserId) === Number(user.user_id),
      items: user.items
    })
  })
  Vue.set(state, 'tradeRevertInventoryUpdates', updates.slice(-maxTradeRevertUpdates))
}

function applyPendingTradeRevertInventory (state) {
  if (!state.all || !state.all.data || !state.all.data.server || !Array.isArray(state.all.data.data) || !Array.isArray(state.tradeRevertInventoryUpdates)) {
    return
  }

  const rows = state.all.data.data.slice()
  let changed = false
  state.tradeRevertInventoryUpdates.forEach(update => {
    if (update.server !== state.all.data.server || !Array.isArray(update.items)) {
      return
    }

    const hasExistingRows = rows.some(row => Number(row.user_id) === update.user_id)
    if (!hasExistingRows && !update.active) {
      return
    }

    update.items.forEach(item => {
      const itemID = Number(item.item_id)
      const qty = Number(item.qty)
      const index = rows.findIndex(row => Number(row.user_id) === update.user_id && Number(row.item_id) === itemID)
      if (qty <= 0) {
        if (index !== -1) {
          rows.splice(index, 1)
          changed = true
        }
        return
      }

      if (index === -1) {
        rows.push({
          item_id: itemID,
          user_id: update.user_id,
          item: item.item,
          qty: qty
        })
        changed = true
        return
      }

      Vue.set(rows, index, Object.assign({}, rows[index], {
        item: item.item || rows[index].item,
        qty: qty
      }))
      changed = true
    })
  })

  if (changed) {
    Vue.set(state.all.data, 'data', rows)
  }
}

// initial state
const state = {
  all: null,
  error: 0,
  tradeRevertInventoryUpdates: []
}

// getters
const getters = {
  allInventory: state => state.all,
  itemError: state => state.error
}

// actions
const actions = {
  getInventory ({ commit }, data) {
    commit('setInventory', data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

// mutations
const mutations = {
  setInventory (state, all) {
    state.all = all
    applyPendingTradeRevertInventory(state)
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  },
  applyTradeRevertInventory (state, payload) {
    rememberTradeRevertInventoryUpdates(state, payload)
    applyPendingTradeRevertInventory(state)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
